export default __webpack_public_path__ + "static/saws-1f479ab52449b8021363cf1bd1911223.png";